angular.module('logbook').directive('tagValueSelector', ['$http', '$uibModal', '$timeout', '$q', '$filter', function($http, $uibModal, $timeout, $q, $filter) {
  return {
    restrict: 'E',

    scope: {
      selectedTagValues: '=',
      selectedTagValueIds: '=?',
      selectedTagValueObjects: '=',
      onChange: '=?',
      onChangeData: '=?',
      targetHref: '=?',
      targetField: '@',
      singleSelect: '=?',
      inputId: '=?',
      inputTabIndex: '=?',
      inputPlaceholder: '=?',
      isDisabled: '=?',
      selectedLog: '=',
      parentTagId: '=?',
      tagDepth: '=?',
      excludeIds: '=?',
      newTagValues: '=?',
      focusOnCreate: '=?',
      minHeight: '=?',
      disableDelete: '=?',
      hideInputOnDisabled: '=?',
      backspaceDelete: '=?'
    },

	template: require('./tag-value-selector.html'),

    link: function(scope, elem, attrs) {
       let lastValue = '';
       scope.resolvedPromise = function()
       {
          var deferred = $q.defer();
          deferred.resolve();
          return deferred.promise;
       }
       
       if(scope.inputId == undefined)
          scope.inputId = 'tag-selector-' + Math.floor(Math.random()*10000);
       scope.selectingTag = '';
       
       scope.tagValueSelected = function(item) {
          var promise = scope.targetHref 
             ? scope.addTagValue(item)
             : scope.resolvedPromise();
          
          lastValue = '';
          scope.selectingTag = '';
          promise.then(function() {
             if( scope.singleSelect )
             {
                scope.selectedTagValues.length = 0;
                if( scope.selectedTagValueIds  )
                   scope.selectedTagValueIds.length=0;
             }
             if( scope.selectedTagValues.indexOf(item._links.self.href) < 0 )
             {
                scope.selectedTagValues.push(item._links.self.href);
                scope.selectedTagValueIds && scope.selectedTagValueIds.push(item.id);
                scope.selectedTagValueObjects.push(item);
             }
             scope.onChange && scope.onChange(scope.onChangeData);
          }, function(error) {
             scope.onChange && scope.onChange(scope.onChangeData);
          });
       };
       
       scope.unSelectTagValue = function(tagValue)
       {
          tagValue = scope.getTagValueFromHref(tagValue);
          if( !tagValue )
             return;
          
          var promise = scope.targetHref
             ? scope.removeTagValue(tagValue)
             : scope.resolvedPromise();

          promise.then(function() {
             scope.selectedTagValues.splice(scope.selectedTagValues.indexOf(tagValue._links.self.href),1);
             scope.selectedTagValueIds && 
                scope.selectedTagValueIds.splice(
                   scope.selectedTagValueIds.indexOf(tagValue.id),
                      1);
             scope.onChange && scope.onChange(scope.onChangeData);
          }, function(error) {
             scope.onChange && scope.onChange(scope.onChangeData);
          });
       };
       
       scope.deleteNewTagValue = function(name)
       {
          scope.newTagValues.splice(scope.newTagValues.indexOf(name), 1);
       };
       
       scope.focusInput = function($event) {
          if( $event && $event.target.hasAttribute('data-delete-button'))
          {
             $event.preventDefault();
             $event.stopPropagation();
             return;
          }
          $('#'+scope.inputId).focus();
       };
       
       scope.currentList = [];
       scope.currentPage = 0;
       scope.lastSearchedPage = -1;
       
       scope.filterTagValues = function($viewValue) {
          if( !scope.selectedLog || (scope.isDisabled && !scope.singleSelect))
             return;
          var deferred = $q.defer();
          scope.loading = true;
          if( scope.currentSearch != $viewValue || !scope.showMore )
          {
             scope.currentList.length = 0;
             scope.currentPage = 0;
             scope.currentSearch = $viewValue;
          }
          scope.showMore = false;
          scope.lastSearchedPage = scope.currentPage;
          var ids = scope.selectedTagValues.map(function(val) { 
             return val.substring(val.lastIndexOf('/')+1);
          });
          if( scope.excludeIds )
             ids = ids.concat(scope.excludeIds);
          var params = {
                'matches': $viewValue,
                'log': scope.selectedLog.id,
                'sort': 'viewString',
                'page': scope.currentPage,
                'excludeId': ids,
                'size': 20
             };
          if( scope.parentTagId )
          {
             params['parentDepthSpec'] = [scope.parentTagId];
             if( scope.tagDepth )
                params['parentDepthSpec'].push(scope.tagDepth);
          }
          
          scope.queryHandle && scope.queryHandle.resolve();
          scope.queryHandle = $q.defer();
          
          $http.get('/api/tagValues', {
             params: params,
             timeout: scope.queryHandle.promise,
             noErrorPopup: true,
             headers: {
                'X-LogBook-Flags': 'disable-page-count-query'
             }
          }).then(function(result) {
             var currentTags = {}
             scope.currentList.forEach(function(tag) {
                 currentTags[tag.id] = true;
             });
             result.data._embedded.tagValues.forEach(function(tv) {
                if( !currentTags[tv.id] )
                   scope.currentList.push(tv);
             })
             scope.loading = false;
             deferred.resolve(scope.currentList);
          }, function(error) {
             deferred.reject(error);
             scope.loading = false;
          });
          return deferred.promise;

       };
       scope.$on('showMore', function(event, id, parent) {
          if( !scope.isOpen )
             return;
          if( scope.loading )
             return;
          scope.loading = true;
          scope.showMore = true;
          $timeout(function() {
             scope.currentPage += 1;
             var el =$('#'+scope.inputId);
             el.focus();
             if( scope.currentSearch )
                parent.$parent.getMatchesAsync(scope.currentSearch);
          }, 30);
       });
       
       scope.deregisterLiRendered = scope.$on('li-rendered', function(event, id, parent) {
          if( !scope.typeaheadScope )
          {
             scope.typeaheadScope = parent;
             parent.getDropdownStyle = function() {
                var pos = parent.position();
                var element = $('[data-tag-selector-id="'+parent.$id+'"]');
                if( !element || !element[0] || !document.documentElement )
                	return;
                var viewWidth = window.innerWidth || document.documentElement.clientWidth;
                var style = { top: pos.top + 'px'};
                if(pos.left + element[0].clientWidth > viewWidth && element[0].clientWidth < viewWidth)
                {
                   style['right'] = 0 + 'px';
                   style['left'] = 'auto';
                }
                else
                {
                   style['left'] = pos.left + 'px';
                   style['right'] = 'auto';
                }
                return style;
             };
          }
          scope.deregisterLiRendered && scope.deregisterLiRendered();
          delete scope.deregisterLiRendered;
       });
       
       scope.$watch('isOpen', function() {
          if( scope.isOpen )
          {
             scope.currentPage=0;
             $timeout(function() {
                var typeaheadMatch = $('.typeahead-match-'+scope.inputId+'-0');
                if( typeaheadMatch && typeaheadMatch.parent() )
                   typeaheadMatch.parent().scrollTop(0);
             });
          }
       });
       
       scope.getDisplayValue = function(tagValueHref)
       {
          var tagValue = scope.getTagValueFromHref(tagValueHref);
          if( tagValue )
             return tagValue.viewString;
          console.log('tagValue not found: ' + tagValueHref);
       };
       
       scope.getTagValueFromHref = function(href)
       {
          if( !scope.selectedTagValueObjects )
             return;
          for (var i=0, tagValue; tagValue=scope.selectedTagValueObjects[i]; i++)
             if( href === tagValue._links.self.href )
                return tagValue;

       };
       scope.getInputWidth = function() 
       {
          var input = $('#'+scope.inputId).val();
          if( !input )
             return '100%';
          var inputLength = input.length;
          if( scope.selectedTagValues.length )
             return Math.max(inputLength, 1).toString() + 'em';
          else
             return '100%';
       };
       scope.$watch('isDisabled', function(newVal, oldVal) {
          if( oldVal && !newVal )
             $timeout(scope.focusInput);
       });
       if( scope.focusOnCreate )
          $timeout(scope.focusInput);
       
       scope.removeTagValue = function($tagValue)
       {
          var upd = {};
          upd[scope.targetField] = null;
          
          return scope.targetField
             ? $http.patch(scope.targetHref,upd)
             : $http.delete(scope.targetHref + $tagValue.id);
       };
       
       scope.addTagValue = function($tagValue)
       {
          var upd = {};
          upd[scope.targetField] = $tagValue._links.self.href;
          
          var promise = scope.targetField
             ? $http.patch(scope.targetHref, upd)
             : $http.post(scope.targetHref,
                  $tagValue._links.self.href,
                  {
                    "headers":  {
                       "Content-type": "text/uri-list"
                    }
                  });
          
          promise.then(function() {
             scope.editingTags = false;
          });
          return promise;
       };
   
       let eventListener;
       if (scope.backspaceDelete)
       {
          eventListener = $(document).on('keydown', `#${scope.inputId}`, function($event){
             $timeout(() => {
                let current = $(this).val();
                if (lastValue === '' && current === '' && $event.keyCode === 8 && scope.selectedTagValues.length)
                {
                   let arrCopy = $filter('orderBy')(scope.selectedTagValues, scope.getDisplayValue);
                   scope.unSelectTagValue(arrCopy[arrCopy.length - 1]);
                }
                lastValue = current;
             })
          })
       }
       
       scope.$on('$destroy', () => {
          if (eventListener)
            $(document).off(eventListener);
       })
       
    }
  };
}]);
